import { useEffect, useState } from "react";

//For monitoring calls on the when follow up modal is open
export const useFollowUpCallLogger = (currentFollowUp) => {
  const [sessionId, setSessionId] = useState(null);

  useEffect(() => {
    let active = true;
    const addCallListener = (e) => {
      const data = e.data;
      switch (data.type) {
        case "rc-active-call-notify":
          if (data?.call?.sessionId) {
            if (currentFollowUp) {
              setSessionId(data?.call?.sessionId);
            }
          }

          break;
        case "end-call":
          // end call event
          setSessionId(null);
          break;
        default:
          break;
      }
    };

    if (active) {
      window.addEventListener("message", addCallListener);
    }

    return () => {
      //when component unmounts make sure listener is removed
      active = false;
      // window.removeEventListener("message", removeIds);
    };
  }, []);
  return {
    sessionId,
  };
};
